
type TtranslationPairs = {
  ID: number;
  Parent_ID: number;
  Source: string;
  Translation: string;
};
type TtranslationTabArray = {
  Active?: boolean;
  ID: number;
  Language_ID: number;
  ParentLanguage: {
    Alpha2: string;
    ID: number;
    Name: string;
  };
  ParentTemplate?: null | any;
  ParentTemplate_ID: number;
  TranslationPairs: TtranslationPairs[];
};
interface ItranslationArray {
  Guid: string;
  ID: number;
  Package: any;
  Package_ID: number | null;
  Pages: any;
  StatusFlag: number;
  Template: any;
}

const resolveTranslation = (
  text: any,
  translations: Array<TtranslationTabArray> | undefined | null,
): any => {
  // If text is not a string, return as-is (could be React element or other non-string value)
  if (!text || typeof text !== 'string') {
    return text || '';
  }

  // Use only the assessment language override (langTemp), never the interface language.
  // Assessment content must reflect the language chosen when opening the assessment,
  // not the UI language. When no override is set (Default), return original English text.
  const lang =
    (typeof window !== 'undefined' && localStorage.getItem('langTemp')) ||
    'en';

  if (!lang || lang === 'en') {
    return text;
  }

  const currentLang = lang.toLowerCase();

  // Try to get translation from server data first
  if (translations && Array.isArray(translations)) {
    const languageBlock = translations.find(
      l => l?.ParentLanguage?.Alpha2?.toLowerCase() === currentLang,
    );

    if (languageBlock && Array.isArray(languageBlock.TranslationPairs)) {
      const pair = languageBlock.TranslationPairs.find(p => p.Source === text);
      if (pair?.Translation) {
        return pair.Translation;
      }
    }
  }

  // No server translation found — return original English text
  return text;
};

export const translateText = (
  text: any,
  translationArray: Array<ItranslationArray>,
) => {
  if (!translationArray || translationArray.length === 0) {
    return text;
  }

  const templateTranslations =
    translationArray?.[0]?.Template?.Translations || [];

  return resolveTranslation(text, templateTranslations);
};

export const translateTabContentText = (
  text: any,
  translationArray: Array<TtranslationTabArray>,
) => {
  return resolveTranslation(text, translationArray);
};

export const truncateLongWords = (text: any, maxLength: number = 10): any => {
  if (typeof text !== 'string') return text;
  return text.split(' ').map(word => {
    if (word.length > maxLength) {
      return word.slice(0, maxLength) + '...';
    }
    return word;
  }).join(' ');
};
